import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchTitles = async () => {
  const { data } = await axios.get(`${API}/titles`);
  return data || {};
};

export const saveTitle = async (index, title, token) => {
  const { data } = await axios.put(
    `${API}/titles/${index}`,
    { title },
    { headers: { "X-Admin-Token": token } }
  );
  return data;
};

export const resetTitle = async (index, token) => {
  const { data } = await axios.delete(`${API}/titles/${index}`, {
    headers: { "X-Admin-Token": token }
  });
  return data;
};
